import React, { useEffect, useState } from "react";
import { InputAdornment, Box, TextField, MenuItem } from "@material-ui/core";
//import {Input} from "antd";
import { FormLabel, Grid, Switch, Typography, makeStyles } from "@material-ui/core";
import Swal from "sweetalert2";
import "./validation.css";
import { domain } from "../../Urls/Services/Api_urls";
import ReactTooltip from "react-tooltip";

import { PinAlt, QuestionMarkCircle } from "iconoir-react";

import { Autocomplete } from "@mui/material";
import { Loader } from "../../Loader/Loader";
import StepperComp from "../Stepper/StepperComp";
import MapComponent from "./Map";
import { handleKeyPress } from "../Apoyo/handleKeyPress";
import { calling } from "../Cotizardor/FuntionCall/calling";
import {
  LETRAS_CASA,
  NUMEROS_CASA,
  NUMEROS_APTO,
  PISOS,
  PISOS_APTO,
  armarComplemento,
  complementoCompleto,
} from "./complemento";

const useStyles = makeStyles({
  underlineSolido: {
    "&.Mui-disabled:before": { borderBottomStyle: "solid" },
  },
});

export default function Validationtest({
  ruta,
  step,
  steps,
  classBack,
  classDiv,
}) {
  const classes = useStyles();
  let direc = "";
  let direcnormal = "";
  let direcnormal1 = "";
  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(false);
  const [ESTRATO, setEstrato] = useState("3");
  const [CITI, setCiti] = useState("Cali");
  const [TIPO_DE_VIA, setTipovia] = useState("");
  const [NOMBRE_NUMEROS_LETRAS_VIA, setNumerovia] = useState("");
  const [PREFIJO_SECTOR_GEOGRAFICO, setPrefijo] = useState("NA");
  const [NUMEROS_LETRAS_VIA_GENERADORA, setNumeroviage] = useState("");
  const [SUFIJO_SECTOR_GEOGRAFICO, setSufijo] = useState("NA");
  const [NUMERO_DE_PLACA, setPlaca] = useState("");
  const [UNIDAD, setUnidad] = useState("");
  const [TIPO_GRUPO, setTipoGrupo] = useState("NO");
  const [GRUPO, setGrupo] = useState("");
  // const [suscribe, setContract] = useState("");
  // const [cc, setCc] = useState("");
  const [TIPO_TERMINAL, setTipoTerminal] = useState("NO");
  const [TERMINAL, setTerminal] = useState("");
  const [COMPLEMENTO, setCOMPLEMENTO] = useState("");
  const [TIPO_COMPLEMENTO, setTipoComplemento] = useState("");
  const [LETRA_COMPLEMENTO, setLetraComplemento] = useState("");
  const [NUM_COMPLEMENTO, setNumComplemento] = useState("");
  const [PISO_APTO, setPisoApto] = useState("");
  const [esConjunto, setEsConjunto] = useState(false);
  const [Activo, setAct] = useState("");
  const [Activo1, setAct1] = useState("none");
  const [Activo2, setAct2] = useState("none");
  // const [Activo3, setAct3] = useState("none");
  // const [Activo4, setAct4] = useState("NO");
  const [fk_gestion__central, setFk] = useState("");
  const [nombre_central, setNombrec] = useState("");
  const [influence, setInfluence] = useState("SI");
  const url = domain + "/portal/validated_availability/";
  const url1 = domain + "/portal/id_unit_availability_id/";
  // const url2 = domain + "/portal/validate_service/";
  // var [emp, setemp] = useState(false);
  const [std1, setstd1] = useState("active");
  const [std2, setstd2] = useState("");
  const [std3, setstd3] = useState("");
  const [std4, setstd4] = useState("");
  const [std5, setstd5] = useState("none");
  const [value, setvalue] = useState("");

  const [mapClicked, setMapClicked] = useState(false);

  useEffect(() => {
    const getData = () => {
      fetch(domain + "/portal/unidades_availability/", {
        method: "GET",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(),
      })
        .then((data) => data.json())
        .then((data) => {
          setData(data.data);
        });
    };
    getData();
  }, []);

  const cambiarvalue = (e) => {
    setvalue(e);

    setFk(e.id__central);
    setNombrec(e.nombre_central);
  };

  const cambiarEstratovalue = (e) => {
    console.log(e);
    setEstrato(e);
    window.sessionStorage.setItem("estrato", e)
    window.localStorage.setItem("estrato", e)
  };

  const rural = (e) => {
    setUnidad("SI");
    setAct("none");
    setInfluence("NO");
    setAct1("");
    setAct2("none");
    setstd1("");
    setstd2("active");
    setstd3("");
    setstd4("");
    setstd5("none");
  };

  const urbana = (e) => {
    setUnidad("NO");
    setAct("");
    setAct1("none");
    setInfluence("SI");
    setstd1("active");
    setstd2("");
    setstd3("");
    setstd4("");
    setstd5("none");
  };

  const map = (e) => {
    setUnidad("NO");
    setAct("none");
    setAct1("none");
    setInfluence("NO");
    setstd1("");
    setstd2("");
    setstd3("active");
    setstd4("none");
    setstd5("");
    setMapClicked(true);
  };

  const getValue1 = (e, val) => {
    if (val === true) {
    } else if (val === false) {
      setUnidad("NO");
      setAct("");
      setAct1("none");
      setInfluence("SI");
    }
  };

  const getValue = (e, val) => {
    if (val === true) {
      setUnidad("SI");
      setInfluence("SI");
      // console.log(influence);
      setAct2("");
      setEsConjunto(true);
      setTipoComplemento("");
      setLetraComplemento("");
      setNumComplemento("");
      setPisoApto("");
      setCOMPLEMENTO("");
    } else if (val === false) {
      setUnidad("NO");
      // console.log(influence);

      setAct2("none");
      setEsConjunto(false);
    }
  };

  // Cada cambio recalcula el complemento completo (un solo texto) que se envía.
  const actualizarComplemento = (cambios) => {
    const n = {
      tipo: TIPO_COMPLEMENTO,
      letra: LETRA_COMPLEMENTO,
      num: NUM_COMPLEMENTO,
      pisoApto: PISO_APTO,
      ...cambios,
    };
    setTipoComplemento(n.tipo);
    setLetraComplemento(n.letra);
    setNumComplemento(n.num);
    setPisoApto(n.pisoApto);
    setCOMPLEMENTO(armarComplemento(n));
  };

  const dosCampos = TIPO_COMPLEMENTO !== "Casa" && TIPO_COMPLEMENTO !== "Apartamento";

  const cambiarTipoComplemento = (e) =>
    actualizarComplemento({ tipo: e.target.value, letra: "", num: "", pisoApto: "" });

  const handleSubmit = (e) => {
    const credentials1 = {
      fk_gestion__central,
      TIPO_GRUPO,
      GRUPO,
      TIPO_TERMINAL,
      TERMINAL,
      COMPLEMENTO,
    };

    direcnormal1 =
      nombre_central.toString() +
      " " +
      TIPO_GRUPO.toString() +
      " " +
      GRUPO.toString() +
      " " +
      TIPO_TERMINAL.toString() +
      " " +
      TERMINAL.toString();

    e.preventDefault();
    if (
      !complementoCompleto({
        tipo: TIPO_COMPLEMENTO,
        letra: LETRA_COMPLEMENTO,
        num: NUM_COMPLEMENTO,
        pisoApto: PISO_APTO,
      })
    ) {
      Swal.fire({
        icon: "warning",
        title: "Dirección incompleta",
        text:
          TIPO_COMPLEMENTO === "Apartamento"
            ? "Selecciona el piso y el No. apto."
            : TIPO_COMPLEMENTO === "Casa"
            ? "Selecciona al menos la letra o el número de la casa."
            : "Selecciona el No. piso.",
      });
      return;
    }
    const credentials = {
      CITI,
      TIPO_DE_VIA,
      NOMBRE_NUMEROS_LETRAS_VIA,
      PREFIJO_SECTOR_GEOGRAFICO,
      SEPARADOR_NUMERAL: "#",
      NUMEROS_LETRAS_VIA_GENERADORA,
      SUFIJO_SECTOR_GEOGRAFICO,
      SEPARADOR_GUION: "-",
      NUMERO_DE_PLACA,
      UNIDAD,
      TIPO_GRUPO,
      GRUPO,
      TIPO_TERMINAL,
      TERMINAL,
      COMPLEMENTO,
    };
    // console.log(credentials);
    direcnormal =
      TIPO_DE_VIA.toString() +
      " " +
      NOMBRE_NUMEROS_LETRAS_VIA.toString() +
      " " +
      PREFIJO_SECTOR_GEOGRAFICO.toString() +
      " # " +
      NUMEROS_LETRAS_VIA_GENERADORA.toString() +
      " " +
      SUFIJO_SECTOR_GEOGRAFICO.toString() +
      " - " +
      NUMERO_DE_PLACA.toString() +
      " " +
      TIPO_GRUPO.toString() +
      " " +
      GRUPO.toString() +
      " " +
      TIPO_TERMINAL.toString() +
      " " +
      TERMINAL.toString();

    if (influence === "NO") {
      try {
        setLoading(true);
        fetch(url1, {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify(credentials1),
        })
          .then(async function (response) {
            if (response.status === 200) {
              direc = await response.json();
              console.log(direc);
              console.log(direcnormal1);
            }
            if (direc.status === 200) {
              Swal.fire({
                title: "Usted tiene cobertura",
                html: "Pasemos a registrar el servicio <br> <b></b>",
                icon: "success",
                timer: 2500,
                timerProgressBar: true,
                didOpen: () => {
                  Swal.showLoading();
                  const b = Swal.getHtmlContainer().querySelector("b");
                  setInterval(() => {
                    b.textContent = Swal.getTimerLeft();
                  }, 100);
                },
              }).then(() => {
                
                window.sessionStorage.setItem("direction", direc.data.address);
                window.sessionStorage.setItem("city_owner", CITI);
                window.sessionStorage.setItem("estrato", ESTRATO);
                window.sessionStorage.setItem("cdo", direc.data.coverage.cdo);
                window.sessionStorage.setItem(
                  "zone",
                  direc.data.coverage.data[0].zona
                );
                window.location.href = ruta;
                if (ESTRATO === "Empresas") {
                  window.sessionStorage.setItem("category", "Empresas");
                } else {
                  window.sessionStorage.setItem("category", "Residencial");
                }
                if (direc.data.localization) {
                  window.sessionStorage.setItem("localization", JSON.stringify(direc.data.localization));
                }
               
              });
            } else {
              Swal.fire({
                title: "No pudimos validar tu cobertura automáticamente",
                text: "¿Quieres que lo validemos por ti?",
                showDenyButton: true,
                showCancelButton: true,
                confirmButtonText: "Si",
                denyButtonText: `No`,
              }).then((result) => {
                /* Read more about isConfirmed, isDenied below */
                if (result.isConfirmed) {
                  calling();
                } else if (result.isDenied) {
                  Swal.fire("No hay disponibilidad en el momento", "", "info");
                }
              });
            }
          })
          .finally(() => {
            setLoading(false);
          });
      } catch (error) {
        Swal.fire({
          title: "Error!",
          text: "No hay disponibilidad en el momento",
          icon: "error",
          confirmButtonText: "Intentar",
        });
        console.error(error);
      }
    } else {
      try {
        setLoading(true);
        fetch(url, {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify(credentials),
        })
          .then(async function (response) {
            if (response.status === 200) {
              direc = await response.json();
            }
            if (direc.status === 200) {
              Swal.fire({
                title: "Usted tiene cobertura",
                html: "Pasemos a registrar el servicio <br> <b></b>",
                icon: "success",
                timer: 2500,
                timerProgressBar: true,
                didOpen: () => {
                  Swal.showLoading();
                  const b = Swal.getHtmlContainer().querySelector("b");
                  setInterval(() => {
                    b.textContent = Swal.getTimerLeft();
                  }, 100);
                },
              }).then(() => {
                
                window.sessionStorage.setItem("direction", direc.data.address);
                window.sessionStorage.setItem("city_owner", CITI);
                window.sessionStorage.setItem("estrato", ESTRATO);
                window.sessionStorage.setItem("cdo", direc.data.coverage.cdo);
                window.sessionStorage.setItem("localization", JSON.stringify(direc.data.localization || null));
                window.sessionStorage.setItem(
                  "zone",
                  direc.data.coverage.data[0].zona
                );
                window.location.href = ruta;
                if (ESTRATO === "Empresas") {
                  window.sessionStorage.setItem("category", "Empresas");
                } else {
                  window.sessionStorage.setItem("category", "Residencial");
                }
               
              });
            } else {
              Swal.fire({
                title: "No pudimos validar tu cobertura automáticamente",
                text: "¿Quieres que lo validemos por ti?",
                icon: "error",
                showDenyButton: true,
                confirmButtonColor: "#0073ae",

                confirmButtonText: "Si",
                denyButtonText: `No, seguir intentando`,
              }).then((result) => {
                if (result.isConfirmed) {
                  calling("Cobertura");
                }
              });
            }
          })
          .finally(() => {
            setLoading(false);
          });
      } catch (error) {
        Swal.fire({
          title: "Error!",
          text: "No hay disponibilidad en el momento",
          icon: "error",
          confirmButtonText: "Intentar",
        });
        console.error(error);
      }
    }
  };

  if (loading) {
    return <Loader />;
  }
  return (
    <div className={`${classDiv} flex flex-col md:flex-row-reverse w-full items-center justify-center min-h-screen`}>
      
      <div className="w-full md:w-1/4 p-4">
        <StepperComp
          steps={steps}
          activeStep={step}
          orientation={"vertical"}
          alternativeLabel={false}
        />
      </div>

      <div className={`${classBack} w-full md:w-3/4 p-4`} >


        <h3 className="h2">
          <b>Comprueba tu cobertura</b>
        </h3>
        <p>Comprobemos si hay fibra en tu casa</p>

        <hr></hr>
        <Box width="100%">
          <FormLabel component="legend">
            Direccion normalizada/Unidad Residencial
          </FormLabel>
          <Grid container spacing={12}>
            <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
              <div
                style={{
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                  width: "100%",
                  padding: "0.5rem",
                }}
              >
                <a
                  className={`btn88 ${std1}`}
                  onClick={urbana}
                  style={{ margin: "0.5rem", padding: "0.5rem" }}
                >
                  Urbana
                </a>
                <a
                  className={`btn88 ${std2}`}
                  onClick={rural}
                  style={{ margin: "0.5rem", padding: "0.5rem" }}
                >
                  Unidad Rural
                </a>
                <a
                  className={`btn88 ${std3}`}
                  onClick={map}
                  style={{ margin: "0.5rem", padding: "0.5rem" }}
                >
                  Rural
                </a>
              </div>
            </Grid>
          </Grid>
        </Box>

        <form onSubmit={handleSubmit}>
          <div className="direccion" style={{ display: Activo }}>
            <div style={{ height: 10 }} />
            <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
              <Box width="100%">
                <TextField
                  style={{ width: "91%", marginBottom: "1rem" }}
                  helperText="Selecciona tu ciudad"
                  value={CITI}
                  label="Ciudad"
                  select
                  required
                  size="small"
                  onChange={(e) => setCiti(e.target.value)}
                >
                  <MenuItem value="NO"></MenuItem>
                  <MenuItem value="Cali">Cali</MenuItem>
                  <MenuItem value="Palmira">Palmira</MenuItem>
                  <MenuItem value="Yumbo">Yumbo</MenuItem>
                  <MenuItem value="Candelaria">Candelaria</MenuItem>
                  <MenuItem value="Puerto tejada">Puerto tejada</MenuItem>
                  <MenuItem value="Jamundi">Jamundi</MenuItem>
                </TextField>
              </Box>
            </Grid>
            <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
              <Box width="100%">
                <TextField
                  style={{ width: "91%", marginBottom: "1rem" }}
                  helperText="Selecciona el estrato"
                  value={ESTRATO}
                  label="Estrato"
                  select
                  required
                  size="small"
                  onChange={(e) => cambiarEstratovalue(e.target.value)}
                >
                  <MenuItem value="1">1</MenuItem>
                  <MenuItem value="2">2</MenuItem>
                  <MenuItem value="3">3</MenuItem>
                  <MenuItem value="4">4</MenuItem>
                  <MenuItem value="5">5</MenuItem>
                  <MenuItem value="6">6</MenuItem>
                </TextField>
              </Box>
            </Grid>

            <Grid container spacing={12}>
              <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
                <Box width="100%">
                  <TextField
                    style={{ width: "31%", marginBottom: "1rem" }}
                    helperText="Via"
                    value={TIPO_DE_VIA}
                    label="Via"
                    select
                    required
                    size="small"
                    onChange={(e) => setTipovia(e.target.value)}
                  >
                    <MenuItem value="CL">Calle</MenuItem>
                    <MenuItem value="KR">Carrera</MenuItem>
                    <MenuItem value="AV">Avenida</MenuItem>
                    <MenuItem value="TV">Transversal</MenuItem>
                    <MenuItem value="DG">Diagonal</MenuItem>
                    <MenuItem value="KM">Kilometro</MenuItem>
                  </TextField>

                  <TextField
                    helperText="Numero de via"
                    placeholder="96"
                    onKeyPress={handleKeyPress}
                    required
                    label="Via"
                    style={{
                      width: "28%",
                      marginBottom: "1rem",
                      marginLeft: "0.5rem",
                      marginRight: "0.5rem",
                    }}
                    InputProps={{
                      startAdornment: (
                        <InputAdornment position="start"></InputAdornment>
                      ),
                    }}
                    value={NOMBRE_NUMEROS_LETRAS_VIA}
                    size="small"
                    onChange={(e) => setNumerovia(e.target.value)}
                  />
                  <TextField
                    style={{ width: "31%" }}
                    value={PREFIJO_SECTOR_GEOGRAFICO}
                    label="Bis, Comp"
                    helperText="prefijo"
                    select
                    size="small"
                    onChange={(e) => setPrefijo(e.target.value)}
                  >
                    <MenuItem value="NA">NA</MenuItem>
                    <MenuItem value={"Bis"}>Bis</MenuItem>
                    <MenuItem value={"Norte"}>Norte</MenuItem>
                    <MenuItem value={"Oeste"}>Oeste</MenuItem>
                    <MenuItem value={"BIS NORTE"}>Bis norte</MenuItem>
                    <MenuItem value={"BIS OESTE"}>Bis oeste</MenuItem>
                  </TextField>
                </Box>
              </Grid>

              <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
                <Box width="100%">
                  <TextField
                    helperText="Numero de via"
                    placeholder="44A"
                    required
                    style={{ width: "31%", marginBottom: "1rem" }}
                    value={NUMEROS_LETRAS_VIA_GENERADORA}
                    InputProps={{
                      startAdornment: (
                        <InputAdornment position="start">#</InputAdornment>
                      ),
                    }}
                    label="Numero"
                    size="small"
                    onChange={(e) => setNumeroviage(e.target.value)}
                  />

                  <TextField
                    style={{
                      width: "28%",
                      marginBottom: "1rem",
                      marginLeft: "0.5rem",
                      marginRight: "0.5rem",
                    }}
                    value={SUFIJO_SECTOR_GEOGRAFICO}
                    label="Bis, Comp"
                    select
                    helperText="sufijo"
                    size="small"
                    onChange={(e) => setSufijo(e.target.value)}
                  >
                    <MenuItem value="NA">NA</MenuItem>
                    <MenuItem value={"Bis"}>Bis</MenuItem>
                    <MenuItem value={"Norte"}>Norte</MenuItem>
                    <MenuItem value={"Oeste"}>Oeste</MenuItem>
                    <MenuItem value={"BIS NORTE"}>Bis norte</MenuItem>
                    <MenuItem value={"BIS OESTE"}>Bis oeste</MenuItem>
                  </TextField>
                  <TextField
                    helperText="Placa via"
                    style={{ width: "31%", marginBottom: "1rem" }}
                    value={NUMERO_DE_PLACA}
                    placeholder="65"
                    required
                    InputProps={{
                      startAdornment: (
                        <InputAdornment position="start">-</InputAdornment>
                      ),
                    }}
                    label="Placa"
                    size="small"
                    onChange={(e) => setPlaca(e.target.value)}
                  />
                  <TextField
                    helperText="Complemento"
                    style={{ width: dosCampos ? "55%" : "46%", marginBottom: "1rem", marginRight: "0.5rem" }}
                    label="Tipo"
                    select
                    size="small"
                    disabled={esConjunto}
                    InputProps={{ className: classes.underlineSolido }}
                    InputLabelProps={{ shrink: true }}
                    SelectProps={{ displayEmpty: true }}
                    value={TIPO_COMPLEMENTO}
                    onChange={cambiarTipoComplemento}
                  >
                    <MenuItem value="">Ninguno</MenuItem>
                    <MenuItem value="Casa">Casa</MenuItem>
                    <MenuItem value="Piso">Piso</MenuItem>
                    <MenuItem value="Apartamento">Apartamento</MenuItem>
                  </TextField>
                  {!dosCampos && (
                    <TextField
                      helperText={TIPO_COMPLEMENTO === "Apartamento" ? "Piso apto" : "Letra de casa"}
                      style={{ width: "22%", marginBottom: "1rem", marginRight: "0.5rem" }}
                      label={TIPO_COMPLEMENTO === "Apartamento" ? "Piso apto" : "Letra"}
                      select
                      size="small"
                      value={TIPO_COMPLEMENTO === "Apartamento" ? PISO_APTO : LETRA_COMPLEMENTO}
                      onChange={(e) =>
                        actualizarComplemento(
                          TIPO_COMPLEMENTO === "Apartamento"
                            ? { pisoApto: e.target.value }
                            : { letra: e.target.value }
                        )
                      }
                    >
                      {(TIPO_COMPLEMENTO === "Apartamento" ? PISOS_APTO : LETRAS_CASA).map((o) => (
                        <MenuItem key={o} value={o}>{o}</MenuItem>
                      ))}
                    </TextField>
                  )}
                  <TextField
                    helperText={dosCampos ? "Número de piso" : "Número"}
                    style={{ width: dosCampos ? "35%" : "22%", marginBottom: "1rem" }}
                    label={TIPO_COMPLEMENTO === "Apartamento" ? "No. apto" : TIPO_COMPLEMENTO === "Casa" ? "No." : "No. Piso"}
                    select
                    size="small"
                    disabled={esConjunto || !TIPO_COMPLEMENTO}
                    InputProps={{ className: classes.underlineSolido }}
                    value={NUM_COMPLEMENTO}
                    onChange={(e) => actualizarComplemento({ num: e.target.value })}
                  >
                    {(TIPO_COMPLEMENTO === "Apartamento"
                      ? NUMEROS_APTO
                      : TIPO_COMPLEMENTO === "Casa"
                      ? NUMEROS_CASA
                      : PISOS
                    ).map((n) => (
                      <MenuItem key={n} value={n}>{n}</MenuItem>
                    ))}
                  </TextField>
                </Box>
              </Grid>
            </Grid>
          </div>
        
          <Box width="100%" style={{ display: Activo }}>
            <FormLabel component="legend">
              Vives en conjunto residencial/Edificio
            </FormLabel>
            <div
              style={{
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
              }}
            >
              <Typography>No</Typography>
              <Switch
                color="primary"
                size="medium"
                labelPlacement="end"
                placeholder="Condominio/conjunto"
                onChange={getValue}
              />
              <Typography>Si</Typography>
            </div>
          </Box>

          <div style={{ display: Activo2 }}>
            <hr></hr>
            <Grid container spacing={12}>
              <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
                <Box width="100%">
                  <TextField
                    style={{
                      width: "44%",
                      marginBottom: "1rem",
                      marginRight: "0.5rem",
                      display: Activo,
                    }}
                    helperText="Grupo"
                    value={TIPO_GRUPO}
                    label="Tipo de grupo"
                    select
                    size="small"
                    id="outlined-basic"
                    onChange={(e) => setTipoGrupo(e.target.value)}
                  >
                    <MenuItem value="NO">NO</MenuItem>
                    <MenuItem value="BLQ">Bloque</MenuItem>
                    <MenuItem value="BDGA">Bodega</MenuItem>
                    <MenuItem value="ET">Etapa</MenuItem>
                    <MenuItem value="LOC">Localidad</MenuItem>
                    <MenuItem value="LT">Lote</MenuItem>
                    <MenuItem value="PARC">Parcelacion</MenuItem>
                    <MenuItem value="PJE">Pasaje</MenuItem>
                    <MenuItem value="SEC">Sector</MenuItem>
                    <MenuItem value="TO">Torre</MenuItem>
                    <MenuItem value="UN">Unidad</MenuItem>
                    <MenuItem value="URB">Urbanizacion</MenuItem>
                    <MenuItem value="MZ">Manzana</MenuItem>
                  </TextField>

                  <TextField
                    helperText="Numero de grupo"
                    style={{
                      width: "44%",
                      marginBottom: "1rem",
                    }}
                    value={GRUPO}
                    label={TIPO_GRUPO}
                    size="small"
                    id="outlined-basic"
                    onChange={(e) => setGrupo(e.target.value)}
                  />
                </Box>
              </Grid>
              <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
                <Box width="100%">
                  <TextField
                    style={{
                      width: "44%",
                      marginBottom: "1rem",
                      marginRight: "0.5rem",
                    }}
                    helperText="Terminal"
                    value={TIPO_TERMINAL}
                    label="Tipo de terminal"
                    select
                    size="small"
                    id="outlined-basic"
                    onChange={(e) => setTipoTerminal(e.target.value)}
                  >
                    <MenuItem value="NO">NO</MenuItem>
                    <MenuItem value="ADM">Administracion</MenuItem>
                    <MenuItem value="ALM">Almacen</MenuItem>
                    <MenuItem value="AP">Apartamento</MenuItem>
                    <MenuItem value="CAB">Cabaña</MenuItem>
                    <MenuItem value="CA">Casa</MenuItem>
                    <MenuItem value="LC">Local</MenuItem>
                    <MenuItem value="PJE">Pasaje</MenuItem>
                    <MenuItem value="OF">Oficina</MenuItem>
                    <MenuItem value="POR">Porteria</MenuItem>
                    <MenuItem value="SA">Salon</MenuItem>
                  </TextField>

                  <TextField
                    helperText="Numero de terminal"
                    style={{
                      width: "44%",
                      marginBottom: "1rem",
                    }}
                    value={TERMINAL}
                    label="Terminal"
                    size="small"
                    onChange={(e) => setTerminal(e.target.value)}
                  />
                </Box>
              </Grid>
            </Grid>
          </div>
          <div className="flex justify-center items-center">
            <button
              style={{ display: Activo }}
              className="flex  items-center mt-5 text-white rounded-xl bg-blue-500 hover:bg-blue-600 active:bg-blue-700 focus:outline-none focus:ring focus:ring-blue-300 ..."
              variant="contained"
              type="submit"
            >
              <PinAlt />
              Buscar
            </button>
          </div>
        </form>
        <div className="Unidades" style={{ display: Activo1 }}>
          <form onSubmit={handleSubmit}>
            <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
              <Box width="100%">
                <TextField
                  style={{ width: "91%", marginBottom: "1rem" }}
                  helperText="Selecciona tu ciudad"
                  value={CITI}
                  label="Ciudad"
                  select
                  required
                  size="small"
                  onChange={(e) => setCiti(e.target.value)}
                >
                  <MenuItem value="NO"></MenuItem>
                  <MenuItem value="Cali">Cali</MenuItem>
                  <MenuItem value="Palmira">Palmira</MenuItem>
                  <MenuItem value="Yumbo">Yumbo</MenuItem>
                  <MenuItem value="Candelaria">Candelaria</MenuItem>
                  <MenuItem value="Puerto tejada">Puerto tejada</MenuItem>
                  <MenuItem value="Jamundi">Jamundi</MenuItem>
                </TextField>
              </Box>
            </Grid>
            <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
              <Box width="100%">
                <TextField
                  style={{ width: "91%", marginBottom: "1rem" }}
                  helperText="Selecciona el estrato"
                  value={ESTRATO}
                  label="Estrato"
                  select
                  required
                  size="small"
                  onChange={(e) => cambiarEstratovalue(e.target.value)}
                >
                  <MenuItem value="1">1</MenuItem>
                  <MenuItem value="2">2</MenuItem>
                  <MenuItem value="3">3</MenuItem>
                  <MenuItem value="4">4</MenuItem>
                  <MenuItem value="5">5</MenuItem>
                  <MenuItem value="6">6</MenuItem>
                </TextField>
              </Box>
            </Grid>
            <Box width="100%">
              <FormLabel component="legend">
                Vives en conjunto residencial/Edificio
              </FormLabel>
              <div
                style={{
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                }}
              >
                <Autocomplete
                  disablePortal
                  id="combo-box-demo"
                  getOptionLabel={(data) =>
                    `${data.nameViewUnit} ${data.id__central}`
                  }
                  options={data}
                  onChange={(event, value) => cambiarvalue(value)}
                  sx={{ width: "90%" }}
                  renderInput={(params) => (
                    <TextField
                      {...params}
                      label="Unidades"
                      required
                      id="outlined-basic"
                    />
                  )}
                />
              </div>
            </Box>
            <hr></hr>
            <Grid container spacing={12}>
              <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
                <Box width="100%">
                  <TextField
                    style={{
                      width: "44%",
                      marginBottom: "1rem",
                      marginRight: "0.5rem",
                      display: Activo1,
                    }}
                    helperText="Grupo"
                    value={TIPO_GRUPO}
                    label="Tipo de grupo"
                    select
                    size="small"
                    id=""
                    onChange={(e) => setTipoGrupo(e.target.value)}
                  >
                    <MenuItem value="NO">NO</MenuItem>
                    <MenuItem value="BLQ">Bloque</MenuItem>
                    <MenuItem value="BDGA">Bodega</MenuItem>
                    <MenuItem value="ET">Etapa</MenuItem>
                    <MenuItem value="LOC">Localidad</MenuItem>
                    <MenuItem value="LT">Lote</MenuItem>
                    <MenuItem value="PARC">Parcelacion</MenuItem>
                    <MenuItem value="PJE">Pasaje</MenuItem>
                    <MenuItem value="SEC">Sector</MenuItem>
                    <MenuItem value="TO">Torre</MenuItem>
                    <MenuItem value="UN">Unidad</MenuItem>
                    <MenuItem value="URB">Urbanizacion</MenuItem>
                    <MenuItem value="MZ">Manzana</MenuItem>
                  </TextField>

                  <TextField
                    helperText="Numero de grupo"
                    style={{
                      width: "44%",
                      marginBottom: "1rem",
                      display: Activo1,
                    }}
                    value={GRUPO}
                    label={TIPO_GRUPO}
                    size="small"
                    id="outlined-basic"
                    onChange={(e) => setGrupo(e.target.value)}
                  />
                </Box>
              </Grid>
              <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
                <Box width="100%">
                  <TextField
                    style={{
                      width: "44%",
                      marginBottom: "1rem",
                      marginRight: "0.5rem",
                      display: Activo1,
                    }}
                    helperText="Terminal"
                    value={TIPO_TERMINAL}
                    label="Tipo de terminal"
                    select
                    size="small"
                    id="outlined-basic"
                    onChange={(e) => setTipoTerminal(e.target.value)}
                  >
                    <MenuItem value="NO">NO</MenuItem>
                    <MenuItem value="ADM">Administracion</MenuItem>
                    <MenuItem value="ALM">Almacen</MenuItem>
                    <MenuItem value="AP">Apartamento</MenuItem>
                    <MenuItem value="CAB">Cabaña</MenuItem>
                    <MenuItem value="CA">Casa</MenuItem>
                    <MenuItem value="LC">Local</MenuItem>
                    <MenuItem value="PJE">Pasaje</MenuItem>
                    <MenuItem value="OF">Oficina</MenuItem>
                    <MenuItem value="POR">Porteria</MenuItem>
                    <MenuItem value="SA">Salon</MenuItem>
                  </TextField>

                  <TextField
                    helperText="Numero de terminal"
                    style={{
                      width: "44%",
                      marginBottom: "1rem",
                      display: Activo1,
                    }}
                    value={TERMINAL}
                    label="Terminal"
                    size="small"
                    id="outlined-basic"
                    onChange={(e) => setTerminal(e.target.value)}
                  />
                </Box>
              </Grid>
            </Grid>
            <div className="flex justify-center items-center">
              <button className="flex  items-center mt-5 text-white rounded-xl bg-blue-500 hover:bg-blue-600 active:bg-blue-700 focus:outline-none focus:ring focus:ring-blue-300 ..." variant="contained" type="submit">
                <PinAlt />
                Buscar
              </button>
            </div>
          </form>
        </div>
        <div style={{ display: std5 }}>
          <div style={{ height: 10 }} />
          <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
            <Box width="100%">
              <TextField
                style={{ width: "91%", marginBottom: "1rem" }}
                helperText="Selecciona tu ciudad"
                value={CITI}
                label="Ciudad"
                select
                required
                size="small"
                onChange={(e) => setCiti(e.target.value)}
              >
                <MenuItem value="NO"></MenuItem>
                <MenuItem value="Cali">Cali</MenuItem>
                <MenuItem value="Palmira">Palmira</MenuItem>
                <MenuItem value="Yumbo">Yumbo</MenuItem>
                <MenuItem value="Candelaria">Candelaria</MenuItem>
                <MenuItem value="Puerto tejada">Puerto tejada</MenuItem>
                <MenuItem value="Jamundi">Jamundi</MenuItem>
              </TextField>
            </Box>
          </Grid>
          <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
            <Box width="100%">
              <TextField
                style={{ width: "91%", marginBottom: "1rem" }}
                helperText="Selecciona el estrato"
                value={ESTRATO}
                label="Estrato"
                select
                required
                size="small"
                onChange={(e) => cambiarEstratovalue(e.target.value)}
              >
                <MenuItem value="1">1</MenuItem>
                <MenuItem value="2">2</MenuItem>
                <MenuItem value="3">3</MenuItem>
                <MenuItem value="4">4</MenuItem>
                <MenuItem value="5">5</MenuItem>
                <MenuItem value="6">6</MenuItem>
              </TextField>
            </Box>
          </Grid>
          <div style={{ height: 10 }} />
          {mapClicked && (
            <MapComponent
              ruta={ruta}
              zoom={12}
              display={""}
              width={"100%"}
              HandleChangeLoading={({ target }) => setLoading(target.value)}
            />
          )}
        </div>
      </div>

    </div>
  );
}
